import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse, sendJson } from 'fetch-utilities';
import 'react-router-redux';
import _Object$assign2 from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _Array$from from 'babel-runtime/core-js/array/from';
import _Reflect$construct from 'babel-runtime/core-js/reflect/construct';
import _Object$setPrototypeOf from 'babel-runtime/core-js/object/set-prototype-of';
import _Object$create from 'babel-runtime/core-js/object/create';
import _typeof from 'babel-runtime/helpers/typeof';
import 'location-search-string';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = _Object$create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = _Reflect$construct(cls, _Array$from(arguments));
    _Object$setPrototypeOf(instance, _Object$getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = _Object$create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_Object$setPrototypeOf) {
    _Object$setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * Base class for application errors, carries an error code unique for the error type.
 */
var AppError = function (_extendableBuiltin2) {
  _inherits(AppError, _extendableBuiltin2);

  function AppError(message, errorCode) {
    _classCallCheck(this, AppError);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, _extendableBuiltin2.call(this, message));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, AppError);
    }

    // Custom

    _this.errorCode = errorCode;
    return _this;
  }

  return AppError;
}(_extendableBuiltin(Error));

/*
  messages.js
  ------------------------------------------------------------

  Generic message management
*/

/**
 * Returns true if we need to run a `load` action on the state.
 */


/**
 * Returns the cart summary.
 */


/**
 * Returns true if the cart is loaded and contains at least one item.
 */


/**
 * Returns the list of actual items in the cart.
 */


/**
 * Retrieves the current item quantity. This might differ from the actual quantity in the cart
 * since we can have pending updates.
 */




/**
 * Returns true if the quantity of the item is synchronized with the server.
 */


/**
 * Modifies a product item, does not require an item id to modify.
 */












/**
 * Creates a handler from a `fetch` instance, using the `/cart` API of Crossroads_API.
 */

var ERROR$1 = "store/checkout/ERROR";
var LOADED$1 = "store/checkout/LOADED";
var LOADED_CART = "store/checkout/LOADED_CART";



var REMOVING$1 = "store/checkout/REMOVING";


var SET_QTY$1 = "store/checkout/SET_QTY";



var SUCCESS = "store/checkout/SUCCESS";

var PENDING = "store/cart/PENDING";
var LOADING = "store/cart/LOADING";
var LOADED$$1 = "store/cart/LOADED";
var ADDING = "store/cart/ADDING";
var ADDED = "store/cart/ADDED";
var PUTTING = "store/cart/PUTTING";
var REMOVING$$1 = "store/cart/REMOVING";
var ERROR$$1 = "store/cart/ERROR";
var SET_QTY$$1 = "store/cart/SET_QTY";
var DELETE = "store/cart/DELETE";

var initialState = {
  state: PENDING,
  loaded: false,
  data: {
    items: [],
    summary: {}
  },
  removingItems: [],
  updatingItems: [],
  addingItems: [],
  addedItems: []
};

function reducer$$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return _extends({}, state, {
        state: action.type
      });

    case DELETE:
    case LOADED$$1:
      return _extends({}, state, {
        state: LOADED$$1,
        loaded: true,
        error: action.error,
        data: action.error ? state.data : action.payload,
        errorData: action.error ? action.payload : null,
        removingItems: action.removeId ? state.removingItems.filter(function (id) {
          return id !== action.removeId;
        }) : state.removingItems,
        updatingItems: action.updateId ? state.updatingItems.filter(function (id) {
          return id !== action.updateId;
        }) : state.updatingItems,
        addingItems: action.addId ? state.addingItems.filter(function (id) {
          return id !== action.addId;
        }) : state.addingItems,
        addedItems: !action.error && action.addId ? [].concat(_toConsumableArray(state.addedItems), [action.addId]) : state.addedItems
      });

    case REMOVING$$1:
      return _extends({}, state, {
        state: action.type,
        removingItems: [].concat(_toConsumableArray(state.removingItems), [action.removeId])
      });

    case ADDING:
      return _extends({}, state, {
        state: action.type,
        addingItems: [].concat(_toConsumableArray(state.addingItems), [action.addId])
      });

    case SET_QTY$$1:
      return _extends({}, state, {
        state: action.type,
        updatingItems: [].concat(_toConsumableArray(state.updatingItems), [action.updateId])
      });

    case ADDED:
      return _extends({}, state, {
        state: action.type,
        addedItems: state.addedItems.filter(function (id) {
          return id !== action.addId;
        })
      });

    case PUTTING:
      return _extends({}, state, {
        state: action.type
      });

    case PENDING:
      return _extends({}, initialState);

    case LOADED$1:
      return _extends({}, state, {
        state: LOADED$$1,
        loaded: true,
        error: action.error,
        errorData: action.error ? action.payload || state.data : null,
        data: action.error ? state.data : action.payload ? action.payload.cart : state.data
      });

    case LOADED_CART:
      return _extends({}, state, {
        state: LOADED$$1,
        loaded: true,
        error: action.error,
        errorData: action.error ? action.payload || state.data : null,
        data: action.error ? state.data : action.payload || state.data
      });

    case REMOVING$1:
    case SET_QTY$1:
      return _extends({}, state, {
        state: state.loaded ? LOADING : state.loaded
      });

    case SUCCESS:
      return _extends({}, initialState, {
        state: LOADED$$1,
        loaded: true
      });

    case ERROR$1:
      if (!state.loaded) {
        return state;
      }

      return _extends({}, state, {
        state: ERROR$$1,
        error: action.payload
      });

    default:
      return state;
  }
}

var load = function load() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: LOADED$$1,
      payload: client("/cart").then(jsonResponse)
    });
  };
};

var add = function add(data) {
  return function (dispatch, getState, client) {
    dispatch({
      type: ADDING,
      addId: data.product.id,
      payload: data
    });

    dispatch({
      type: LOADED$$1,
      addId: data.product.id,
      payload: client("/cart", sendJson({ body: data })).then(jsonResponse).then(function (cart) {
        setTimeout(function () {
          return dispatch(added(data.product.id));
        }, 2000);

        return cart;
      }).catch(function (error) {
        throw error.errorCode ? error : { errorCode: "NETWORK_ERROR", cause: error };
        return getState().cart.data;
      })
    });
  };
};

var put = function put(items) {
  return function (dispatch, getState, client) {
    var body = {
      items: items.map(function (item) {
        return {
          product: {
            id: item.productId
          },
          qty: item.qty,
          attributes: item.attributes
        };
      })
    };

    dispatch({
      type: PUTTING,
      payload: body
    });

    dispatch({
      type: LOADED$$1,
      payload: client("/cart", sendJson({ method: "PUT", body: body })).then(jsonResponse).catch(function (error) {
        throw error.errorCode ? error : { errorCode: "NETWORK_ERROR", cause: error };
        return getState().cart.data;
      })
    });
  };
};

var added = function added(id) {
  return {
    type: ADDED,
    addId: id
  };
};

var remove = function remove(item) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: REMOVING$$1,
      removeId: item.id,
      payload: item
    });

    dispatch({
      type: LOADED$$1,
      removeId: item.id,
      payload: client("/cart/" + item.id, { method: "DELETE" }).then(jsonResponse)
    });
  };
};

var setQty = function setQty(item, qty) {
  return function (dispatch, _getState, client) {
    if (qty === 0) {
      return dispatch(remove(item));
    }

    dispatch({
      type: SET_QTY$$1,
      updateId: item.id
    });

    dispatch({
      type: LOADED$$1,
      payload: client("/cart/" + item.id, sendJson({ method: "PUT", body: _extends({}, item, { qty: qty }) })).then(jsonResponse),
      updateId: item.id
    });
  };
};

var reset = function reset() {
  return {
    type: PENDING
  };
};

var empty = function empty() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: DELETE,
      payload: client("/cart", { method: "DELETE" }).then(jsonResponse)
    });
  };
};

export { PENDING, LOADING, LOADED$$1 as LOADED, ADDING, ADDED, PUTTING, REMOVING$$1 as REMOVING, ERROR$$1 as ERROR, SET_QTY$$1 as SET_QTY, DELETE, load, add, put, added, remove, setQty, reset, empty };
export default reducer$$1;
